<script lang="ts">
    import {afterUpdate, onMount} from "svelte";
    import {Input, Label} from "flowbite-svelte";
    import {IconSolid, PenNibSolid} from "flowbite-svelte-icons";

    export let id = "input-" + Math.random().toString(36);
    export let label = ''
    export let value = ''
    export let key;

    export let icon = PenNibSolid
    export let extract = (item) => item;

    let searchRef = null;
    let suggestions = [];

    let suggestion = '';
    afterUpdate(() => {
        if(localStorage.getItem(key)){
            suggestions = JSON.parse(localStorage[key])
        }
    })

    function suggest(){
        suggestion = suggestions.find(x => x.toLowerCase().includes(value.toLowerCase())) || '';
    }
    function storeSuggestion(){
        if(!suggestions.includes(value)){
            suggestions.push(value)
        }
        localStorage.setItem(key, JSON.stringify(suggestions))
    }
    $: shadowSuggestion = () =>{

        if(value.length < suggestion.length){
            return '<span style="color: transparent">' + suggestion.substring(0,value.length) + '</span>' + suggestion.substring(value.length)
        }
        return ''
    }

</script>
<div class="relative">
<!--    FIX eventually-->
<!--    <span class="text-neutral-500 absolute top-1 py-1.5 pl-3 z-0 sm:text-sm sm:leading-6">{@html shadowSuggestion()}</span>-->
    <Label class="space-y-2 mb-3 ">
        <span>{label}</span>
        <Input bind:this={searchRef}
               required
               on:blur={storeSuggestion}
               on:input={suggest}
               bind:value
               on:keydown={(e) => {
                switch (e.key) {
                    case "Enter":
                    case "Tab":
                        if(suggestion !== ''){
                            e.preventDefault();
                            value = suggestion
                            suggestion = ''
                        }
                }
            }}>
            <IconSolid slot="left" class="text-primary-400" {icon}/>
        </Input>

    </Label>
</div>

